import { QueryClient } from '@tanstack/react-query'

/**
 * App-wide QueryClient. Defaults chosen for an internal ERP dashboard:
 * - refetchOnWindowFocus off — avoids a refetch storm every time the user
 *   alt-tabs back during a demo.
 * - staleTime 30s — a read is considered fresh for 30s, so navigating between
 *   pages that share a query key does not refetch on every mount.
 * - retry 1 — one silent retry, then surface the error (our UI renders it).
 * - gcTime 5min — unused cache entries are dropped 5 minutes after the last
 *   observer unmounts (React Query default; stated here for clarity).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
})
